export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';

export const API_DATETIME_FORMAT = 'YYYYMMDDhhmmss';
export const API_DATE_FORMAT = 'YYYYMMDD';